import { InfoCard, StylovyzeTable } from '@innovyze/stylovyze';
import { StylovyzeHeader } from '@innovyze/lib_am_common';
import React from 'react';
import { Grid } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';

export interface RiskLoFCoFProps {
	isLoading: boolean;
	lofTableCells: string[][];
	cofTableCells: string[][];
}

export const RiskSetupLoFCoF = ({
	isLoading,
	lofTableCells,
	cofTableCells,
}: RiskLoFCoFProps) => {
	const { t } = useGlobalization();
	const headerReactNodes = (): StylovyzeHeader[] => {
		return [
			{
				key: 'category',
				cell: t('Category'),
				sortable: false,
				align: 'left',
				maxWidth: '200px',
				width: '25%',
			},
			{
				key: 'categoryWeight',
				cell: t('Category Weight'),
				sortable: false,
				align: 'left',
				width: '25%',
			},
			{
				key: 'component',
				cell: t('Component'),
				sortable: false,
				align: 'left',
				maxWidth: '200px',
				width: '25%',
			},
			{
				key: 'componentWeight',
				cell: t('Component Weight'),
				sortable: false,
				align: 'left',
				width: '25%',
			},
		];
	};

	return (
		<InfoCard title={t('Risk Setup')}>
			<Grid container>
				<Grid item xs={12}>
					<StylovyzeTable
						className="ScrollTable"
						title={t('LoF (Likelihood of Failure)')}
						dataCy="lof-table"
						headers={headerReactNodes()}
						rows={
							lofTableCells.map(
								(row: string[], nRow: number) => ({
									key: nRow,
									cells: row,
								}),
							) || []
						}
						initialized={!isLoading}
					/>
				</Grid>
				<Grid item xs={12} style={{ paddingTop: '20px' }}>
					<StylovyzeTable
						className="ScrollTable"
						title={t('CoF (Consequence of Failure)')}
						dataCy="cof-table"
						headers={headerReactNodes()}
						rows={
							cofTableCells.map(
								(row: string[], nRow: number) => ({
									key: nRow,
									cells: row,
								}),
							) || []
						}
						initialized={!isLoading}
					/>
				</Grid>
			</Grid>
		</InfoCard>
	);
};
